// Vanity constants
export const VERSION_DISPLAY = 'v0.0.0-alpha'
